var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"v-chip--select-multi",attrs:{"pill":"","small":_vm.small}},[_c('v-avatar',{staticClass:"white--text",class:[_vm.chipColor, _vm.small ? 'small' : ''],attrs:{"left":""},domProps:{"textContent":_vm._s(_vm.initials)}}),_vm._v(" "+_vm._s(_vm.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }